import type { AppModel } from "app/client/models/AppModel";
import type { App } from "app/client/ui/App";
import type { DomContents } from "grainjs";

export class OAuthFlowUI {
  public static buildOAuthFlow(appModel: AppModel, appObj: App): DomContents { return null; }
}
